<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-row dense>
      <v-col cols="12" sm="6" md="3">
        <v-select
          outlined
          dense
          clearable
          v-model="filtros.modelo"
          :items="modelosPermitidos"
          item-text="text"
          item-value="value"
          label="Entidade"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-select
          outlined
          dense
          clearable
          v-model="filtros.acao"
          :items="acoes"
          item-text="text"
          item-value="value"
          label="Ação"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="12" md="4" v-if="user.tipo == 'ADMIN'">
        <v-autocomplete
          outlined
          dense
          clearable
          v-model="filtros.empresaId"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Empresa"
          no-data-text="Nenhuma empresa encontrada"
        ></v-autocomplete>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12" sm="6" lg="2">
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              light
              :value="formatDate(filtros.dataInicial)"
              label="De"
              append-icon="event"
              readonly
              v-on="on"
              outlined
              dense
            ></v-text-field>
          </template>
          <v-date-picker v-model="filtros.dataInicial" locale="pt-br" no-title @input="menu1 = false"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6" lg="2">
        <v-menu
          ref="menu2"
          v-model="menu2"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              light
              :value="formatDate(filtros.dataFinal)"
              label="Até"
              append-icon="event"
              readonly
              v-on="on"
              outlined
              dense
            ></v-text-field>
          </template>
          <v-date-picker v-model="filtros.dataFinal" locale="pt-br" no-title @input="menu2 = false"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="12" lg="1">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn dark fab small color="#01579B" v-on="on" @click="aplicarFiltros()">
              <v-icon>search</v-icon>
            </v-btn>
          </template>
          <span>Pesquisar</span>
        </v-tooltip>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="cabecalhoTabela"
          :items="tabela.conteudo"
          :options.sync="opcoes"
          :server-items-length="totalRegistros"
          disable-sort
          class="elevation-1"
          style="border-radius: 10px;"
          :loading="tabela.carregamento"
          loading-text="Aguarde, buscando registros..."
          :footer-props="{
            'items-per-page-text': 'Linhas por página',
            'items-per-page-options': [10, 20, 50, 100],
          }"
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">AUDITORIA</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn text tile color="#3BA8A2" :disabled="totalRegistros == 0" @click="exportar()">
                <v-icon left>mdi-microsoft-excel</v-icon>Exportar Excel
              </v-btn>
            </v-toolbar>
          </template>
          <template slot="no-data">
            <v-row>
              <v-col>
                <v-alert dark dense text outlined :value="true" color="warning" class="mt-4" icon="info">Nenhum registro de auditoria encontrado</v-alert>
              </v-col>
            </v-row>
          </template>
          <template v-slot:[`item.created`]="{ item }">
            <p style="margin: 0px; white-space: nowrap;">{{ formatarDataHora(item.created) }}</p>
          </template>
          <template v-slot:[`item.modelo`]="{ item }">
            <p style="margin: 0px">{{ rotuloModelo(item.modelo) }}</p>
          </template>
          <template v-slot:[`item.acao`]="{ item }">
            <v-chip small dark :color="corAcao(item.acao)">{{ rotuloAcao(item.acao) }}</v-chip>
          </template>
          <template v-slot:[`item.usuarioNome`]="{ item }">
            <p style="margin: 0px" v-if="item.usuarioId">{{ item.usuarioNome }}</p>
            <p style="margin: 0px; color: #aaa; font-style: italic;" v-else>— sistema —</p>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click="verDetalhes(item)">
                  <v-icon color="#01579B">mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>Ver detalhes</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- Detalhes do registro de auditoria -->
    <v-dialog v-model="dialogoDetalhes" max-width="750px" scrollable>
      <v-card v-if="detalhe">
        <v-card-title>
          <v-chip small dark :color="corAcao(detalhe.acao)" class="mr-2">{{ rotuloAcao(detalhe.acao) }}</v-chip>
          {{ rotuloModelo(detalhe.modelo) }}
        </v-card-title>
        <v-card-text class="pt-2">
          <v-row dense>
            <v-col cols="12">
              <v-text-field outlined dense hide-details readonly :value="detalhe.descricao || '-----'" label="Descrição"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field outlined dense hide-details readonly :value="rotuloAcao(detalhe.acao)" label="Ação"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field outlined dense hide-details readonly :value="rotuloModelo(detalhe.modelo)" label="Entidade"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field outlined dense hide-details readonly :value="formatarDataHora(detalhe.created)" label="Data/Hora"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field outlined dense hide-details readonly :value="detalhe.usuarioId ? detalhe.usuarioNome : '— sistema —'" label="Autor"></v-text-field>
            </v-col>
            <!-- Dados técnicos do autor: somente ADMIN -->
            <template v-if="ehAdmin">
              <v-col cols="12" sm="6">
                <v-text-field outlined dense hide-details readonly :value="detalhe.usuarioEmail || '-----'" label="E-mail do autor"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field outlined dense hide-details readonly :value="detalhe.ip || '-----'" label="IP"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea outlined dense hide-details readonly auto-grow rows="1" :value="detalhe.userAgent || '-----'" label="User-agent"></v-textarea>
              </v-col>
            </template>
          </v-row>

          <!-- Transferência de aluno entre professores -->
          <div v-if="detalhe.acao == 'TRANSFERENCIA' && detalhe.dados" class="mt-4">
            <p class="tituloSecao">Transferência</p>
            <v-row dense>
              <v-col cols="12">
                <v-text-field outlined dense hide-details readonly :value="detalhe.dados.alunoNome || '-----'" label="Aluno"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field outlined dense hide-details readonly :value="detalhe.dados.professorOrigemNome || '-----'" label="Professor de origem"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field outlined dense hide-details readonly :value="detalhe.dados.professorDestinoNome || '-----'" label="Professor de destino"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea outlined dense hide-details readonly auto-grow rows="1" :value="detalhe.dados.justificativa || '-----'" label="Motivo"></v-textarea>
              </v-col>
            </v-row>
          </div>

          <!-- Campos alterados (somente em edição) -->
          <div v-if="detalhe.acao == 'UPDATE' && detalhe.alteracoes" class="mt-4">
            <p class="tituloSecao">Campos alterados</p>
            <v-simple-table dense class="tabelaAlteracoes">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>Campo</th>
                    <th>De</th>
                    <th>Para</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(valor, campo) in detalhe.alteracoes" :key="campo">
                    <td class="font-weight-medium">{{ campo }}</td>
                    <td><pre class="valorJson">{{ formatarValor(valor.de) }}</pre></td>
                    <td><pre class="valorJson">{{ formatarValor(valor.para) }}</pre></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>

          <!-- Registro bruto (JSON): somente ADMIN -->
          <div v-if="ehAdmin && detalhe.dados" class="mt-4">
            <p class="tituloSecao">{{ detalhe.acao == 'DELETE' ? 'Registro excluído' : 'Registro' }}</p>
            <pre class="valorJson bloco">{{ formatarValor(detalhe.dados) }}</pre>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialogoDetalhes = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Snackbar ref="chamaSnackbar" />
    <loading :active.sync="isLoading" :can-cancel="false" color="#3BA8A2" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import moment from 'moment'
  import { exportarParaExcel } from '@/utils/excel'

  export default {
    components: { Snackbar, Loading },
    data: () => ({
      isLoading: false,
      fullPage: true,
      empresas: [],
      modelos: [
        { text: 'Usuário', value: 'Usuario' },
        { text: 'Empresa', value: 'Empresa' },
        { text: 'Professor', value: 'Professor' },
        { text: 'Aluno', value: 'Aluno' },
        { text: 'Aula (transferência)', value: 'ServicePainel' },
      ],
      acoes: [
        { text: 'Cadastro', value: 'CREATE' },
        { text: 'Edição', value: 'UPDATE' },
        { text: 'Exclusão', value: 'DELETE' },
        { text: 'Transferência', value: 'TRANSFERENCIA' },
      ],
      filtros: {
        modelo: null,
        acao: null,
        empresaId: null,
        dataInicial: moment().format('YYYY-MM-DD'),
        dataFinal: moment().format('YYYY-MM-DD'),
      },
      // cópia dos filtros da última pesquisa: paginação e exportação seguem o que está na tabela
      filtrosAplicados: {
        modelo: null,
        acao: null,
        empresaId: null,
        dataInicial: moment().format('YYYY-MM-DD'),
        dataFinal: moment().format('YYYY-MM-DD'),
      },
      menu1: false,
      menu2: false,
      opcoes: {
        page: 1,
        itemsPerPage: 20,
      },
      totalRegistros: 0,
      tabela: {
        cabecalho: [
          { text: 'Data/Hora', value: 'created', align: 'start' },
          { text: 'Entidade', value: 'modelo' },
          { text: 'Descrição', value: 'descricao' },
          { text: 'Ação', value: 'acao' },
          { text: 'Autor', value: 'usuarioNome' },
          { text: 'IP', value: 'ip' },
          { text: 'Detalhes', value: 'action', sortable: false, align: 'center' },
        ],
        conteudo: [],
        carregamento: false,
      },
      dialogoDetalhes: false,
      detalhe: null,
    }),

    computed: {
      ...mapState({
        user: state => state.userObj,
        companyobj: state => state.companyObj,
      }),

      ehAdmin() {
        return this.user.tipo == 'ADMIN'
      },

      // Auditoria de Usuário e Empresa é exclusiva do ADMIN (o backend também restringe)
      modelosPermitidos() {
        return this.ehAdmin ? this.modelos : this.modelos.filter(m => m.value != 'Usuario' && m.value != 'Empresa')
      },

      // IP é dado técnico exibido apenas ao ADMIN
      cabecalhoTabela() {
        return this.ehAdmin ? this.tabela.cabecalho : this.tabela.cabecalho.filter(c => c.value != 'ip')
      },
    },

    watch: {
      // Paginação no servidor: qualquer mudança de página/linhas por página recarrega
      // (o v-data-table emite as opções ao montar, o que dispara a primeira busca)
      opcoes: {
        handler() {
          this.carregaLogs()
        },
        deep: true,
      },
    },

    mounted() {
      if (this.ehAdmin) {
        this.carregaEmpresas()
      }
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
        .catch(() => {
          this.$refs.chamaSnackbar.snack('#EF5350', 'Erro ao carregar as empresas, tente novamente', 'DESCULPE')
        })
      },

      aplicarFiltros() {
        this.filtrosAplicados = Object.assign({}, this.filtros)

        if (this.opcoes.page != 1) {
          this.opcoes.page = 1 // o watch dispara o carregaLogs
        } else {
          this.carregaLogs()
        }
      },

      // Monta a query string da consulta com os filtros aplicados, omitindo os vazios
      // @limiteFinal - moment opcional que limita a data final (exportação: ignora logs gerados durante o laço)
      montaUrlConsulta(pagina, porPagina, limiteFinal) {
        const filtros = this.filtrosAplicados
        let url = baseApiUrl + 'LogsAuditoria/consultar?access_token=' + sessionStorage.getItem('accToken')
        const empresaId = this.user.tipo == 'ADMIN' ? filtros.empresaId : this.companyobj.id
        let dataFinal = filtros.dataFinal ? moment(filtros.dataFinal, 'YYYY-MM-DD').endOf('day') : null

        if (limiteFinal && (!dataFinal || limiteFinal.isBefore(dataFinal))) dataFinal = limiteFinal

        if (filtros.modelo) url += '&modelo=' + encodeURIComponent(filtros.modelo)
        if (filtros.acao) url += '&acao=' + encodeURIComponent(filtros.acao)
        if (empresaId) url += '&empresaId=' + encodeURIComponent(empresaId)
        if (filtros.dataInicial) url += '&dataInicial=' + encodeURIComponent(moment(filtros.dataInicial, 'YYYY-MM-DD').startOf('day').toISOString())
        if (dataFinal) url += '&dataFinal=' + encodeURIComponent(dataFinal.toISOString())

        return url + '&pagina=' + pagina + '&porPagina=' + porPagina
      },

      async carregaLogs() {
        this.tabela.carregamento = true
        try {
          const response = await axios.get(this.montaUrlConsulta(this.opcoes.page, this.opcoes.itemsPerPage))
          this.tabela.conteudo = (response.data && response.data.dados) || []
          this.totalRegistros = (response.data && response.data.total) || 0
        } catch (error) {
          this.tabela.conteudo = []
          this.totalRegistros = 0
          this.mostraErro(error, 'Erro ao consultar a auditoria')
        } finally {
          this.tabela.carregamento = false
        }
      },

      mostraErro(error, mensagem) {
        if (error && error.response && error.response.status == 403) {
          this.$refs.chamaSnackbar.snack('#EF5350', 'Você não tem permissão para consultar a auditoria', 'ATENÇÃO')
        } else {
          this.$refs.chamaSnackbar.snack('#EF5350', mensagem + ', tente novamente', 'DESCULPE')
        }
      },

      verDetalhes(item) {
        this.detalhe = item
        this.dialogoDetalhes = true
      },

      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatarDataHora(data) {
        return data ? moment(data).format('DD/MM/YYYY HH:mm:ss') : ''
      },

      formatarValor(valor, compacto) {
        if (valor === null || valor === undefined) return '—'
        if (typeof valor === 'object') return compacto ? JSON.stringify(valor) : JSON.stringify(valor, null, 2)
        return String(valor)
      },

      rotuloModelo(modelo) {
        const m = this.modelos.find(x => x.value == modelo)
        return m ? m.text : modelo
      },

      rotuloAcao(acao) {
        const a = this.acoes.find(x => x.value == acao)
        return a ? a.text : acao
      },

      corAcao(acao) {
        if (acao == 'CREATE') return 'green'
        if (acao == 'UPDATE') return 'orange'
        if (acao == 'DELETE') return 'red'
        if (acao == 'TRANSFERENCIA') return 'blue'
        return 'grey'
      },

      // Texto "campo: de → para; ..." usado na planilha
      textoAlteracoes(alteracoes) {
        if (!alteracoes) return ''
        return Object.keys(alteracoes).map(campo => {
          const valor = alteracoes[campo] || {}
          return campo + ': ' + this.formatarValor(valor.de, true) + ' → ' + this.formatarValor(valor.para, true)
        }).join('; ')
      },

      // Exporta todos os registros do filtro atual, buscando página a página
      async exportar() {
        this.isLoading = true
        const porPagina = 200
        let registros = []
        let pagina = 1
        let total = 0
        const limiteFinal = moment()

        try {
          do {
            const response = await axios.get(this.montaUrlConsulta(pagina, porPagina, limiteFinal))
            const dados = (response.data && response.data.dados) || []
            total = (response.data && response.data.total) || 0
            registros = registros.concat(dados)
            pagina++
            if (dados.length == 0) break
          } while (registros.length < total)

          if (registros.length == 0) {
            this.$refs.chamaSnackbar.snack('orange', 'Nenhum registro para exportar', 'ATENÇÃO')
            return
          }

          const linhas = registros.map(r => {
            let linha = {
              'Data/Hora': this.formatarDataHora(r.created),
              'Entidade': this.rotuloModelo(r.modelo),
              'Descrição': r.descricao || '',
              'Ação': this.rotuloAcao(r.acao),
              'Autor': r.usuarioId ? (r.usuarioNome || '') : '— sistema —',
            }

            // Dados técnicos do autor: somente ADMIN
            if (this.ehAdmin) {
              linha['E-mail do autor'] = r.usuarioEmail || ''
              linha['IP'] = r.ip || ''
            }

            linha['Alterações'] = r.acao == 'UPDATE' ? this.textoAlteracoes(r.alteracoes) : ''
            linha['Motivo da transferência'] = r.acao == 'TRANSFERENCIA' && r.dados ? (r.dados.justificativa || '') : ''

            return linha
          })

          await exportarParaExcel(linhas, 'Auditoria ' + new Date().toLocaleString('pt-BR') + '.xlsx', 'Auditoria')
        } catch (error) {
          this.mostraErro(error, 'Erro ao exportar a auditoria')
        } finally {
          this.isLoading = false
        }
      },
    },
  }
</script>

<style scoped>
  .tituloSecao {
    font-weight: bold;
    color: #00253E;
    font-size: 15px;
    margin-bottom: 8px;
  }

  /* o CSS global das telas deixa o texto do cabeçalho branco */
  .tabelaAlteracoes th {
    color: rgba(0, 0, 0, 0.6) !important;
    font-size: 13px;
  }

  .valorJson {
    font-family: 'Courier New', monospace;
    font-size: 12px;
    white-space: pre-wrap;
    word-break: break-word;
    margin: 0;
  }

  .valorJson.bloco {
    background: #f5f7fa;
    border: 1px solid #e0e0e0;
    border-radius: 5px;
    padding: 10px;
    max-height: 320px;
    overflow: auto;
  }
</style>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
    font-size: 14px;
  }
</style>
